module.exports = __webpack_public_path__ + "static/media/interface_usability.e93b2ed1.webp";